import * as React from "react";
import * as Moment from "moment";
import { List, Map } from "immutable";
import { noResultsText, Region } from "../../custom_api/api";
import { ActivityEditionN } from "../../custom_models/activity_edition";
import { trackActivitySubscribe } from "./library/tracking";
import { moment } from "../../custom_utils/moment";
import { Book } from "./books_block";

export interface ActivityEditionListProps {
  readonly regions: Map<string, Region>;
  readonly editions: List<ActivityEditionN>;
}

export interface ActivityEditionListState { }

const activityEditionListStateZero: ActivityEditionListState = {}

const sortEditionsByDateAscending: (
  x: ActivityEditionN,
  y: ActivityEditionN
) => number = (x, y) => (x.activityEvents.first().date < y.activityEvents.first().date ? -1 : 1);

const ActivityEditionElement: (edition: ActivityEditionN) => JSX.Element = e => {
  return (
    <li className="edition">
      <div className="edition__column edition__column--first">
        {e.activityEvents.sort((a, b) => a.date < b.date ? -1 : 1).map((e, k) => {
          const date = moment(new Date(e.date.getTime() - e.date.getTimezoneOffset() * 60000)).format("dddd D MMMM YYYY")
          return (
            <div className="edition__event" key={`edition-event-${date}`}>
              <span className="sr-text">Waar en wanneer: </span>
              <time dateTime={moment(e.date).format('YYYY-MM-DD')}>{date.charAt(0).toUpperCase() + date.slice(1)}</time>
              <span>{e.start} - {e.end}</span>
              <address>{e.location}</address>
            </div>
          )
        })}
      </div>


      <div className="edition__column edition__column--second">
        <div className="edition__info">
          <span className="sr-text">Meer informatie: </span>
          {e.signupText && (
            <div className="text--styled">{e.signupText}</div>
          )}

          {e.signupUrl &&
            <div className="edition__signup edition__signup--mobile" aria-hidden="true">
              <a
                href={e.signupUrl}
                target="_blank"
                className="button button--primary button--arrow"
                onClick={() =>
                  e.activityEvents.map(event => (
                    trackActivitySubscribe(
                      Moment(event.date).format("DD/MM/YYYY"),
                      event.start,
                      event.end
                    )
                  ))
                }
              >
                <span className="button__label">Meld je aan</span>
              </a>
            </div>
          }

          {e.book && (
            <aside className="edition__book">
              <Book
                title={e.book.title}
                author={e.book.author}
                imageUrl={'/image' + e.book.image}
                imageAlt={`Boekentip ${e.book.title} - ${e.book.author}`}
                className="book--single"
                url={e.book.url}
              />
            </aside>
          )}
        </div>

        {e.signupUrl &&
          <div className="edition__signup edition__signup--desktop">
            <a
              href={e.signupUrl}
              target="_blank"
              className="button button--primary button--arrow"
              onClick={() =>
                e.activityEvents.map(event => (
                  trackActivitySubscribe(
                    Moment(event.date).format("DD/MM/YYYY"),
                    event.start,
                    event.end
                  )
                ))
              }
            >
              <span className="button__label">Meld je aan</span>
            </a>
          </div>
        }
      </div>

    </li>
  );
}

export class ActivityEditionList extends React.Component<ActivityEditionListProps, ActivityEditionListState> {
  constructor(props: ActivityEditionListProps) {
    super(props)

    this.state = activityEditionListStateZero
  }

  render() {
    const p = this.props

    const editions: JSX.Element = (
      <section className="edition-list">
        <div className="edition-list__header title--s">
          <h2 className="sr-text">Overzicht met activiteiten: </h2>
          <span className="edition__column edition__column--first" aria-hidden="true">Waar en wanneer</span>
          <span className="edition__column edition__column--second" aria-hidden="true">Meer informatie</span>
        </div>

        {p.editions.isEmpty() ? (
          <div className="text--styled">
            <p className="weight--bold container--s">{noResultsText}</p>
          </div>
        ) : (
          <ul className="editions">
            {p.editions
                .sort(sortEditionsByDateAscending)
                .take(20)
                .map((x, i) => (<ActivityEditionElement {...x} key={`edition-${i}`} />))
                .toArray()}
          </ul>
        )}
      </section>
    )

    return <>{editions}</>
  }
}

{/* TH: Added to styleguide! */}
